import { render, staticRenderFns } from "./workbench.vue?vue&type=template&id=38e79158&"
import script from "./workbench.vue?vue&type=script&lang=js&"
export * from "./workbench.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports